import { useCallback, useRef, useState } from "react";

export const useUploadingState = () => {
  const uploadingRef = useRef(false);
  const [isUploading, setIsUploading] = useState(false);

  const onUploadingChange = useCallback((uploading: boolean) => {
    uploadingRef.current = uploading;
    setIsUploading(uploading);
  }, []);

  return { isUploading, uploadingRef, onUploadingChange };
};
